import { ErrorBoundary } from '@sentry/react';
import { useNotification } from '@wheely/ui-kit';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { setErrorHandler } from '@/app/actions';
import { getFatalErrorSlug } from '@/app/store/selectors';
import { AppDispatch } from '@/root-store';

import { MainLayout } from '../MainLayout';

import { ErrorBySlug } from './ErrorBySlug';

const ErrorWrapper = ({ children }: { children: React.ReactElement }): any => {
  const { showNotification } = useNotification();

  const dispatch: AppDispatch = useDispatch();

  useEffect(() => {
    dispatch(
      setErrorHandler(message => showNotification({ showCloseButton: false, dark: true, message })),
    );
  }, [dispatch, showNotification]);

  const fatalError = useSelector(getFatalErrorSlug);

  return (
    <ErrorBoundary>
      {fatalError ? (
        <MainLayout>
          <ErrorBySlug slug={fatalError} />
        </MainLayout>
      ) : (
        children
      )}
    </ErrorBoundary>
  );
};

export { ErrorWrapper };
